import { all } from 'redux-saga/effects';
import google from 'sagas/analytics/google';

export default function* analytics() {
  yield all([google()]);
}
